export default class SpaceMetadata {
  constructor(
    public readonly name: string,
  ) {
  }
}
